export default {
  saveStockOrder({commit}, stockOrder) {
    return new Promise((resolve, reject) => {
      commit('SAVE_STOCK_ORDER', stockOrder)
      resolve().catch((error) => {
        reject(error);
      })
    })
  },
  setStockOrderList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_STOCK_ORDER_LIST', payload);
      resolve().catch((error => {
        reject(error);
      }));
    });
  },
  setEmptyStockOrder({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_EMPTY_STOCK_ORDER', payload);
      resolve().catch((error => {
        reject(error);
      }));
    });
  },
  approveStockOrder({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('APPROVE_STOCK_ORDER', payload)
      resolve().catch((error => {
        reject(error);
      }));
    });
  },
  canceledStockOrder({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('CANCELED_STOCK_ORDER', payload)
      resolve().catch((error => {
        reject(error);
      }));
    });
  },
  preparingStockOrder({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('PREPARING_STOCK_ORDER', payload)
      resolve().catch((error => {
        reject(error);
      }));
    });
  },
  changeStateStockOrder({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('CHANGE_STATE_STOCK_ORDER', payload)
      resolve().catch((error => {
        reject(error);
      }));
    });
  }
};
